import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, Grid, Typography } from '@mui/material'

import BackButton from '../../../components/back-button'
import ScreenContainer from '../../../components/screen'
import SensorActivationFooter from '../../../components/sensor-activation-footer'
import ExampleImage1 from '../../../images/leak-freeze-activation/placement-suggestions/example1.svg'
import ExampleImage2 from '../../../images/leak-freeze-activation/placement-suggestions/example2.svg'
import ExampleImage3 from '../../../images/leak-freeze-activation/placement-suggestions/example3.svg'
import ExampleImage4 from '../../../images/leak-freeze-activation/placement-suggestions/example4.svg'
import { useActivationContext } from '../../../providers/activation-provider'
import useStyles from '../index.styles'
import ProbePlacementModal from '../probe-placement-modal'

const PlacementSuggestionsLeakFreeze = () => {
  const classes = useStyles
  const navigate = useNavigate()
  const [probeModalOpen, setProbeModalOpen] = useState<boolean>(false)
  const { activationLocationState } = useActivationContext()

  return (
    <ScreenContainer
      useDarkBackground={true}
      headerProps={{
        title: 'Activate',
        showDownloadAppButton: false,
        leftIcon: <BackButton />,
        useDarkBackground: true,
        progress: 65,
      }}
      footerSpacing={148}
    >
      <Grid container={true} sx={classes.lfOuterContainer}>
        <Grid container={true} sx={classes.lfTextContainer}>
          <Typography variant="body2" sx={classes.whereToPlaceText}>
            Where to Place
          </Typography>

          <Typography variant="h6" sx={classes.lfHeading}>
            <span style={classes.textEmphasis}>Lay flat</span> on the floor in bathrooms, kitchens, or utility rooms for leak detection.
          </Typography>

          <Typography variant="h6" sx={classes.lfHeading}>
            Or <span style={classes.textEmphasis}>mount to a wall</span> in a temperature-controlled room using the included adhesive strip.
          </Typography>
        </Grid>

        <Grid container={true} size={12} sx={classes.lfImagesContainer}>
          <Grid size={5} sx={classes.lfImageItem}>
            <img src={ExampleImage1} alt="Example of the sensor laid flat on the floor" width="100%" />
          </Grid>

          <Grid size={5} sx={classes.lfImageItem}>
            <img src={ExampleImage2} alt="Example of the sensor mounted on a wall" width="100%" />
          </Grid>

          <Grid size={5} sx={classes.lfImageItem}>
            <img src={ExampleImage3} alt="Example of the sensor laid flat on the floor in a utility room next to a laundry machine" width="100%" />
          </Grid>

          <Grid size={5} sx={classes.lfImageItem}>
            <img src={ExampleImage4} alt="Example of the sensor laid flat on the floor next to a water heater" width="100%" />
          </Grid>
        </Grid>
      </Grid>

      <SensorActivationFooter
        primaryButton={
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => navigate('/sensor-location', { state: activationLocationState })}
            sx={classes.nextButtonPaddingX}
          >
            Next
          </Button>
        }
        secondaryButton={
          <Button variant="text" onClick={() => setProbeModalOpen(true)}>
            Optional Probe Instructions
          </Button>
        }
      />
      <ProbePlacementModal isOpen={probeModalOpen} onClose={() => setProbeModalOpen(false)} />
    </ScreenContainer>
  )
}

export default PlacementSuggestionsLeakFreeze
